<script lang="ts" setup>
import { getIcon } from '@/shared/Icons';
import { getCachedMarkerIcon } from '@/shared/renderers/renderMarkerIcon';
import { ref, computed, watch, onMounted } from 'vue';
import { useStore } from '@/store/Store';
import type { ComputedMarker } from '@/shared/types/zod';

const props = defineProps<{
	icon?: string;
	color?: string;
	square?: boolean;
	mergeProps?: ComputedMarker["properties"];
}>();

const store = useStore();

const markerVariation = computed(() => {
	return store.map?.markerVariation ?? 'default';
});

const dataUrl = ref("");

function update() {
	const iconData = getIcon(props.icon!);
	const color = iconData.fixedColor ?? props.color;
	const canvas = getCachedMarkerIcon(iconData, color!, {
		variation: props.mergeProps?.__markerVariation ?? markerVariation.value,
		text: props.mergeProps?.text,
		bare: props.square === true,
	}, update);
	dataUrl.value = canvas ? canvas.toDataURL() : "";
}

const cssStyles = computed((): string => {
	if (markerVariation.value === 'invert') return '';
	return props.square ? `background-color:${props.color}` : '';
});

watch(() => props.icon, () => {
	update();
});

watch(() => props.color, () => {
	update();
});

watch(markerVariation, () => {
	update();
});

onMounted(() => {
	update();
});

</script>


<template>
	<div class="marker-wrapper" :style="cssStyles">
		<img :src="dataUrl" />
	</div>
</template>


<style scoped>
.marker-wrapper {
	width: 100%;
	height: 100%;
	display: flex;
	justify-content: center;
	align-items: center;

	padding: 0 !important;
}

img {
	width: 100%;
	height: 100%;
	padding: 0 !important;
	object-fit: contain;
}
</style>
